import 'rc-tooltip/assets/bootstrap.css';
import React from 'react';
import RCTooltip from 'rc-tooltip';
import { TooltipProps as RCTooltipProps } from 'rc-tooltip/es/Tooltip';

export type TooltipProps = RCTooltipProps;

export const Tooltip: React.FC<TooltipProps> = ({
  placement = 'top',
  trigger = ['hover'],
  children,
  destroyTooltipOnHide = { keepParent: true },
  ...rest
}) => {
  return (
    <RCTooltip placement={placement} trigger={trigger} {...rest}>
      {children}
    </RCTooltip>
  );
};
